import { MAX_DAY_SECONDS } from '@studio/constants/events';
import { militaryTimeToSeconds } from '@studio/helpers/unitConversion/militaryTimeToSeconds';

const getPreEventBuffer = (encoderStartTime?: string, contentStartTime?: string): number => {
  if (encoderStartTime && contentStartTime) {
    const encoderStart = militaryTimeToSeconds(encoderStartTime);
    const contentStart = militaryTimeToSeconds(contentStartTime);
    if (encoderStart > contentStart) {
      // NOTE: means encoderStart is on previous day
      const diff = MAX_DAY_SECONDS - encoderStart;
      return (contentStart + diff) / 60;
    }
    return (contentStart - encoderStart) / 60;
  }
  return 0;
};

export default getPreEventBuffer;
